import { UserDto } from './user.dto';
import { InterestSourcesEnum } from '../../enums/interest-sources.enum';
import { IsBoolean, IsOptional, MinLength, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { FileUploadDto, FileDto } from './file.dto';
import { Base64AllowedMimeTypes, MaxBase64FileSize } from '../../decorators';
import { ALLOWED_INTEREST_ICON_MIME_TYPES } from '../../constants';

export class InterestDto {
	public id: string;
	public name: string;
	public sourceId?: InterestSourcesEnum;
	public createdUserId?: string;
	public iconId?: string;
	public hasPriorityOverNativeAsset: boolean;

	public source?: InterestSourcesDto;
	public icon?: FileDto;
}

export class InterestToUserDto {
	public id: string;
	public userId: string;
	public interestId: string;
	public masteryLevel: number;
	public user: UserDto;
	public interest: InterestDto;
	public deletedAt: Date;
}

export class AddInterestToUserDto {
	public masteryLevel: number | null;
	public interestId: string;
}

export class UpdateInterestDto {
	@MinLength(2)
	public name: string;

	@ValidateNested()
	@Type(() => FileUploadDto)
	@MaxBase64FileSize(20)
	@Base64AllowedMimeTypes(ALLOWED_INTEREST_ICON_MIME_TYPES)
	public iconImg?: FileUploadDto;

	@IsOptional()
	@IsBoolean()
	public hasPriorityOverNativeAsset?: boolean;
}

export class CreateInterestDto extends UpdateInterestDto {
	public sourceId: InterestSourcesEnum;
}

export class CreateInterestAsAdminDto extends UpdateInterestDto {

}

export class CreateInterestAsUserDto extends UpdateInterestDto {

}

export class InterestSourcesDto {
	public id: InterestSourcesEnum;
	public name: string;
}
